import React from "react";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import '../assests/Css/menu.css'
import CoffeeTea from '../assests/images/category/icon-2.png'

const BrowserCat = (props) => {
  const ref = useRef(null);
  const [toggle, setToggle] = useState(false);
  const [flag, setFlag] = useState(true);

  const { onClickOutside } = props;
  const [show, setShow] = useState(props.show);
  // console.log('sidebar '+show);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  // console.log(categories);

  return (
          <div ref={ref} className={show ? 'categories-dropdown-wrap categories-dropdown-active-large font-heading open' : 'categories-dropdown-wrap categories-dropdown-active-large font-heading'}>
            <div className="d-flex categories-dropdown-inner">
              {props.categories &&
                <div className="">
                  <div>
                    <ul className="menu_list">
                      {(props.categories.map((catgs, index) => {
                        return (
                          // <div className="menu_list">

                          catgs.categories.map((category, index) => {
                            // if (index<(apiDetails.categories.length/2)) {
                            return (
                              <NavLink key={index} className="NavLink" to={"/product-categories/" + category.id + '/' + category.category_name} onClick={() => setToggle(!toggle)}>
                                {category.category_image ? (

                                  <li><img src={axios.defaults.baseURL.slice(0, -4) + "frontend/images/category_images/" + category.category_image} alt={category.category_name} width="30" height="30" />&nbsp;&nbsp;&nbsp;
                                    {category.category_name}</li>
                                ) : (<li><img src={CoffeeTea} alt={category.category_name} width="30" height="30" />&nbsp;&nbsp;&nbsp;
                                {category.category_name}</li>)}

                              </NavLink>

                            );
                          })
                        )
                      })
                      )}
                    </ul>
                  </div>
                </div>
              }

            </div>
          </div>
  );
};
export default BrowserCat;
